module.exports = __webpack_public_path__ + "static/media/create_event.341dcf45.png";